export const translations = {
  it: {
    nav: { home: "Home", about: "Chi Siamo", services: "Servizi", menu: "Menù", gallery: "Galleria", reservation: "Prenota", contact: "Contatti", book: "Prenota", catering: "Catering" },
    hero: {
      badge: "Dal 2008 · Passione autentica",
      title1: "Il sapore autentico",
      title2: "della",
      highlight: "Sardegna",
      subtitle: "Un'esperienza che inizia sul piatto e continua nel cuore. Cucina italiana e sarda, pizzeria d'autore e catering per i tuoi momenti più speciali.",
      ctaMenu: "Scopri il Menù",
      ctaBook: "Prenota il tuo tavolo",
      ctaDelivery: "Ordina a domicilio",
      reviews: "oltre {n} recensioni",
      scroll: "Scorri",
    },
    about: {
      badge: "Chi Siamo",
      title1: "Un ristorante di famiglia,",
      highlight: "una passione autentica",
      p1: "L'angolo del Gusto è un ristorante di famiglia con una passione per la cucina italiana autentica e oltre 40 anni di esperienza nel settore. Ci troviamo nel cuore della Sardegna, presso il complesso commerciale Torre Eleonora a Oristano.",
      p2: "Ci impegniamo ogni giorno a offrire ai nostri ospiti un'esperienza culinaria eccezionale in un ambiente caloroso, accogliente e familiare. La nostra famiglia e il nostro staff sono pronti ad accoglierti per soddisfare ogni tua esigenza.",
      pillar1: "40+ anni", pillar1s: "di esperienza",
      pillar2: "Famiglia", pillar2s: "& tradizione",
      pillar3: "Ingredienti", pillar3s: "freschi e locali",
      years: "anni con voi",
    },
    services: {
      badge: "Cosa Offriamo", title1: "Quattro anime,", highlight: "un solo gusto",
      items: {
        gastronomia: { title: "Gastronomia", desc: "Una vasta scelta di piatti freschi ogni giorno, dai sapori sardi di mare e di terra alla tradizione italiana autentica.", cta: "Scopri" },
        pizzeria: { title: "Pizzeria", desc: "Oltre 40 anni di esperienza per la ricetta della pizza perfetta: impasto a lunga lievitazione e ingredienti selezionati.", cta: "Ordina ora" },
        fastfood: { title: "Fast-Food", desc: "Panini gourmet e sfiziosità che ti portano dritto in America, senza rinunciare alla qualità artigianale.", cta: "Ordina ora" },
        catering: { title: "Catering & Eventi", desc: "La nostra location e il servizio catering sono ciò che cerchi per rendere indimenticabile il tuo evento speciale.", cta: "Richiedi" },
      },
    },
    menu: { badge: "Il Menù", title1: "Sapori di mare,", highlight: "terra e tradizione", note: "Una selezione dei nostri piatti — il menù completo cambia con le stagioni." },
    reservation: {
      badge: "Prenotazioni", title1: "Prenota il tuo", highlight: "tavolo",
      subtitle: "Compila il modulo e ti confermeremo la disponibilità al più presto. Per gruppi ed eventi speciali, aggiungi una nota.",
      name: "Nome e cognome", phone: "Telefono", date: "Data", time: "Orario", guests: "Persone", notes: "Note (opzionale)",
      email: "Email (per ricevere conferma)", emailPh: "nome@email.it",
      notesPh: "Allergie, occasione speciale, richieste particolari...",
      submit: "Invia richiesta", sending: "Invio in corso...",
      okTitle: "Richiesta inviata!", okDesc: "Grazie! Ti ricontatteremo per confermare la prenotazione.",
      errTitle: "Compila i campi obbligatori", errDesc: "Nome, telefono, data e orario sono necessari.",
      failTitle: "Ops, qualcosa è andato storto", failDesc: "Riprova o chiamaci direttamente.",
    },
    cateringSection: {
      badge: "Catering & Eventi", title1: "Il tuo evento,", highlight: "il nostro sapore",
      subtitle: "Portiamo la cucina de L'angolo del Gusto ovunque tu voglia: matrimoni, cerimonie, feste private ed eventi aziendali. Menù su misura, servizio curato e la qualità di sempre.",
      items: [
        { title: "Matrimoni & Cerimonie", desc: "Buffet e menù raffinati per il tuo giorno speciale." },
        { title: "Eventi Aziendali", desc: "Coffee break, business lunch e cene di gala." },
        { title: "Feste Private", desc: "Compleanni, anniversari e ricorrenze in famiglia." },
        { title: "Buffet & Rinfreschi", desc: "Ricche proposte dolci e salate per ogni occasione." },
        { title: "Menù Personalizzati", desc: "Creiamo il menù su misura per te, anche vegetariano." },
        { title: "Servizio Completo", desc: "Personale, allestimento e tutto il necessario." },
      ],
      cta: "Richiedi un preventivo",
    },
    gallery: { badge: "Galleria", title1: "Ogni piatto,", highlight: "una storia" },
    catering: {
      badge: "Catering & Eventi", title1: "Rendi indimenticabile", title2: "il tuo", highlight: "evento speciale",
      subtitle: "Il nostro servizio catering e la nostra location a due piani sono ciò che stai cercando: cene di coppia, gruppi, cerimonie ed eventi aziendali. Il nostro staff si occuperà di ogni dettaglio.",
      cta: "Richiedi un preventivo",
    },
    testimonials: { badge: "Recensioni", title1: "Le parole dei", highlight: "nostri ospiti", ratingText: "su Google · {n} recensioni" },
    contact: {
      badge: "Contatti", title1: "Ti aspettiamo a", highlight: "Oristano",
      subtitle: "Contattaci per prenotazioni, eventi e catering a domicilio. La nostra famiglia è pronta ad accoglierti.",
      address: "Indirizzo", phone: "Telefono", email: "Email", hours: "Orari di apertura",
      formTitle: "Scrivici un messaggio", name: "Nome", namePh: "Il tuo nome", emailPh: "nome@email.it",
      message: "Messaggio", messagePh: "Come possiamo aiutarti?", submit: "Invia messaggio", sending: "Invio in corso...",
      okTitle: "Messaggio inviato!", okDesc: "Grazie, ti risponderemo al più presto.",
      errTitle: "Compila tutti i campi", errDesc: "Nome, email e messaggio sono obbligatori.",
      failTitle: "Ops, qualcosa è andato storto", failDesc: "Riprova o chiamaci direttamente.",
    },
    footer: { tagline: "Ristorante · Pizzeria · Catering", desc: "Il sapore autentico della Sardegna, con oltre 40 anni di passione per la cucina italiana di famiglia.", nav: "Naviga", where: "Dove siamo", order: "Ordina online", rights: "Tutti i diritti riservati.", made: "Realizzato con passione in Sardegna" },
    days: { mon: "Lunedì", tue: "Martedì", wed: "Mercoledì", thu: "Giovedì", fri: "Venerdì", sat: "Sabato", sun: "Domenica", closed: "Chiuso" },
  },
  en: {
    nav: { home: "Home", about: "About", services: "Services", menu: "Menu", gallery: "Gallery", reservation: "Book", contact: "Contact", book: "Book a table", catering: "Catering" },
    hero: {
      badge: "Since 2008 · Authentic passion",
      title1: "The authentic taste",
      title2: "of",
      highlight: "Sardinia",
      subtitle: "An experience that begins on the plate and continues in the heart. Italian and Sardinian cuisine, signature pizzeria and catering for your most special moments.",
      ctaMenu: "Explore the Menu",
      ctaBook: "Book your table",
      ctaDelivery: "Order delivery",
      reviews: "over {n} reviews",
      scroll: "Scroll",
    },
    about: {
      badge: "About Us",
      title1: "A family restaurant,",
      highlight: "an authentic passion",
      p1: "L'angolo del Gusto is a family restaurant with a passion for authentic Italian cuisine and over 40 years of experience. We are located in the heart of Sardinia, at the Torre Eleonora shopping centre in Oristano.",
      p2: "Every day we strive to offer our guests an exceptional culinary experience in a warm, welcoming and family atmosphere. Our family and staff are ready to welcome you and satisfy every need.",
      pillar1: "40+ years", pillar1s: "of experience",
      pillar2: "Family", pillar2s: "& tradition",
      pillar3: "Ingredients", pillar3s: "fresh & local",
      years: "years with you",
    },
    services: {
      badge: "What We Offer", title1: "Four souls,", highlight: "one taste",
      items: {
        gastronomia: { title: "Gastronomy", desc: "A wide choice of fresh dishes every day, from Sardinian sea and land flavours to authentic Italian tradition.", cta: "Discover" },
        pizzeria: { title: "Pizzeria", desc: "Over 40 years of experience for the perfect pizza recipe: long-leavened dough and selected ingredients.", cta: "Order now" },
        fastfood: { title: "Fast-Food", desc: "Gourmet burgers and tasty treats that take you straight to America, without compromising on craft quality.", cta: "Order now" },
        catering: { title: "Catering & Events", desc: "Our venue and catering service are exactly what you're looking for to make your special event unforgettable.", cta: "Request" },
      },
    },
    menu: { badge: "The Menu", title1: "Flavours of the sea,", highlight: "land and tradition", note: "A selection of our dishes — the full menu changes with the seasons." },
    reservation: {
      badge: "Reservations", title1: "Book your", highlight: "table",
      subtitle: "Fill in the form and we'll confirm availability as soon as possible. For groups and special events, add a note.",
      name: "Full name", phone: "Phone", date: "Date", time: "Time", guests: "Guests", notes: "Notes (optional)",
      email: "Email (to receive confirmation)", emailPh: "name@email.com",
      notesPh: "Allergies, special occasion, particular requests...",
      submit: "Send request", sending: "Sending...",
      okTitle: "Request sent!", okDesc: "Thank you! We'll get back to you to confirm your reservation.",
      errTitle: "Fill in the required fields", errDesc: "Name, phone, date and time are required.",
      failTitle: "Oops, something went wrong", failDesc: "Please try again or call us directly.",
    },
    cateringSection: {
      badge: "Catering & Events", title1: "Your event,", highlight: "our flavour",
      subtitle: "We bring the cuisine of L'angolo del Gusto wherever you like: weddings, ceremonies, private parties and corporate events. Tailor-made menus, attentive service and our signature quality.",
      items: [
        { title: "Weddings & Ceremonies", desc: "Refined buffets and menus for your special day." },
        { title: "Corporate Events", desc: "Coffee breaks, business lunches and gala dinners." },
        { title: "Private Parties", desc: "Birthdays, anniversaries and family celebrations." },
        { title: "Buffet & Receptions", desc: "Rich sweet and savoury options for any occasion." },
        { title: "Custom Menus", desc: "We create a tailor-made menu for you, vegetarian too." },
        { title: "Full Service", desc: "Staff, setup and everything you need." },
      ],
      cta: "Request a quote",
    },
    gallery: { badge: "Gallery", title1: "Every dish,", highlight: "a story" },
    catering: {
      badge: "Catering & Events", title1: "Make your", title2: "special", highlight: "event unforgettable",
      subtitle: "Our catering service and two-floor venue are exactly what you're looking for: couple dinners, groups, ceremonies and corporate events. Our staff will take care of every detail.",
      cta: "Request a quote",
    },
    testimonials: { badge: "Reviews", title1: "The words of", highlight: "our guests", ratingText: "on Google · {n} reviews" },
    contact: {
      badge: "Contact", title1: "We look forward to seeing you in", highlight: "Oristano",
      subtitle: "Contact us for reservations, events and home catering. Our family is ready to welcome you.",
      address: "Address", phone: "Phone", email: "Email", hours: "Opening hours",
      formTitle: "Send us a message", name: "Name", namePh: "Your name", emailPh: "name@email.com",
      message: "Message", messagePh: "How can we help you?", submit: "Send message", sending: "Sending...",
      okTitle: "Message sent!", okDesc: "Thank you, we'll reply as soon as possible.",
      errTitle: "Fill in all fields", errDesc: "Name, email and message are required.",
      failTitle: "Oops, something went wrong", failDesc: "Please try again or call us directly.",
    },
    footer: { tagline: "Restaurant · Pizzeria · Catering", desc: "The authentic taste of Sardinia, with over 40 years of passion for family Italian cuisine.", nav: "Navigate", where: "Where we are", order: "Order online", rights: "All rights reserved.", made: "Made with passion in Sardinia" },
    days: { mon: "Monday", tue: "Tuesday", wed: "Wednesday", thu: "Thursday", fri: "Friday", sat: "Saturday", sun: "Sunday", closed: "Closed" },
  },
};